import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponsibleContactDetailsComponent } from './responsible-contact-details/responsible-contact-details.component';
import { BaseComponent } from '../../shared/components/base/base.component';
import { TitleService } from '../../shared/services/title.service';
import { MetadataService } from '../../shared/services/metadata.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.css'],
  standalone: true,
  imports: [CommonModule, ResponsibleContactDetailsComponent],
})
export class ImprintComponent extends BaseComponent implements OnInit {
  constructor(
    private metadataService: MetadataService,
    private titleService: TitleService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleService.setTitle(`Imprint`);

    this.metadataService.updateTags(
      `Impressum`,
      `Hier erfahren Sie, wer für aSchwartz.de verantwortlich ist.`,
      `Impressum Kontaktmöglichkeiten`,
    );
  }
}
